<app-ot-breadcrumbs state="summary" [city]="city" [otEvent]="otEvent"></app-ot-breadcrumbs>

<form #summaryForm="ngForm" novalidate *ngIf="otEvent">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
          <h1>{{ 'summary_title' | l10n }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <app-ot-event-info [otEvent]="otEvent" *ngIf="otEvent"></app-ot-event-info>
      </div>
      <div class="col-lg-4" *ngIf="registration.paymentTypeConfig">
        <app-registration-pricing-info
          [registration]="registration"
          [changeLink]="'/city/' + city?.id + '/ot/event/' + otEvent?.id + '/registration/price'"></app-registration-pricing-info>
      </div>
      <div class="col-lg-4">
        <app-person-info [registration]="registration" [changeLink]="'/city/' + city?.id + '/ot/event/' + otEvent?.id + '/registration/person'"></app-person-info>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div *ngIf="otEvent.organization.useCaptcha">
          <label>{{ 'captcha' | l10n }}:</label>
          <ngx-recaptcha2
            name="recaptcha"
            [siteKey]="environment.recaptchaSiteKey"
            [hl]="environment.locale"
            (expire)="onRecaptchaExpired(recaptcha.valueAccessor)"
            [(ngModel)]="recaptchaValue"
            required
            #recaptchaField="ngModel">
          </ngx-recaptcha2>
          <div *ngIf="submitted && recaptcha?.invalid">
            {{ 'captcha_invalid' | l10n }}
          </div>
          </div>
        <button type="button" class="btn btn-primary mt2em" (click)="goToNextStep(summaryForm.valid, (recaptchaField ? recaptchaField.valueAccessor : null))">{{ 'summary_orderButton' | l10n }} <fa-icon [icon]="['fas', 'chevron-right']" class="button-icon-right"></fa-icon></button>
      </div>
    </div>
    <!--
    <div class="row">
      <div class="col-lg-12">

      </div>
    </div>
    -->
  </div>
</form>
